import Albums from './Albums';
import ApiApps from './ApiApps';
import ApiInformation from './ApiInformation';
import AuthenticationExtras from './AuthenticationExtras';
import Categories from './Categories';
import Channels from './Channels';
import CinemaProgramming from './CinemaProgramming';
import Configs from './Configs';
import DeveloperSite from './DeveloperSite';
import Documents from './Documents';
import EmbedPresets from './EmbedPresets';
import ExactTarget from './ExactTarget';
import Groups from './Groups';
import GuestInterview from './GuestInterview';
import JobMarketplace from './JobMarketplace';
import LastViews from './LastViews';
import Likes from './Likes';
import Live from './Live';
import Locations from './Locations';
import Me from './Me';
import Notifications from './Notifications';
import OnDemand from './OnDemand';
import Portfolios from './Portfolios';
import Products from './Products';
import Projects from './Projects';
import RPC from './RPC.jsx';
import Search from './Search';
import Songs from './Songs';
import Stock from './Stock';
import Tags from './Tags';
import Teams from './Teams';
import Tutorial from './Tutorial';
import Users from './Users';
import Videos from './Videos';
import WatchLaterQueue from './WatchLaterQueue';

const ShowcaseFeature = 'showcases';
const CategoriesFeature = 'categories';
const ChannelsFeature = 'channels';
const EmbedPresetsFeature = 'embed-presets';
const GroupsFeature = 'groups';
const LikesFeature = 'likes';
const PortfoliosFeature = 'portfolios';
const FoldersFeature = 'folders';
const TagsFeature = 'tags';
const UsersFeature = 'users';
const VideosFeature = 'videos';
const WatchLaterQueueFeature = 'watch-later-queue';
const LiveFeature = 'live';
const ApiAppsFeature = 'api-apps';
const ApiInformationFeature = 'api-information';
const AuthenticationExtrasFeature = 'authentication-extras';
const CinemaProgrammingFeature = 'cinema-programming';
const ConfigsFeature = 'configs';
const DeveloperSiteFeature = 'developer-site';
const DocumentsFeature = 'documents';
const ExactTargetFeature = 'exacttarget';
const GuestInterviewFeature = 'guest-interview';
const JobMarketplaceFeature = 'job-marketplace';
const LastViewsFeature = 'last-views';
const LocationsFeature = 'locations';
const MeFeature = 'me';
const NotificationsFeature = 'notifications';
const OnDemandFeature = 'on-demand';
const ProductsFeature = 'products';
const SearchFeature = 'search';
const SongsFeature = 'songs';
const StockFeature = 'stock';
const TeamsFeature = 'teams';
const TutorialFeature = 'tutorial';
const RPCFeature = 'remote-procedure-calls';

const getFeature = (group) => {
  switch (group) {
    case ShowcaseFeature:
      return <Albums />;
    case CategoriesFeature:
      return <Categories />;
    case ChannelsFeature:
      return <Channels />;
    case EmbedPresetsFeature:
      return <EmbedPresets />;
    case GroupsFeature:
      return <Groups />;
    case LikesFeature:
      return <Likes />;
    case PortfoliosFeature:
      return <Portfolios />;
    case FoldersFeature:
      return <Projects />;
    case TagsFeature:
      return <Tags />;
    case UsersFeature:
      return <Users />;
    case VideosFeature:
      return <Videos />;
    case WatchLaterQueueFeature:
      return <WatchLaterQueue />;
    case LiveFeature:
      return <Live />;
    case ApiAppsFeature:
      return <ApiApps />;
    case ApiInformationFeature:
      return <ApiInformation />;
    case AuthenticationExtrasFeature:
      return <AuthenticationExtras />;
    case CinemaProgrammingFeature:
      return <CinemaProgramming />;
    case ConfigsFeature:
      return <Configs />;
    case DeveloperSiteFeature:
      return <DeveloperSite />;
    case DocumentsFeature:
      return <Documents />;
    case ExactTargetFeature:
      return <ExactTarget />;
    case GuestInterviewFeature:
      return <GuestInterview />;
    case JobMarketplaceFeature:
      return <JobMarketplace />;
    case LastViewsFeature:
      return <LastViews />;
    case LocationsFeature:
      return <Locations />;
    case MeFeature:
      return <Me />;
    case NotificationsFeature:
      return <Notifications />;
    case OnDemandFeature:
      return <OnDemand />;
    case ProductsFeature:
      return <Products />;
    case SearchFeature:
      return <Search />;
    case SongsFeature:
      return <Songs />;
    case StockFeature:
      return <Stock />;
    case TeamsFeature:
      return <Teams />;
    case TutorialFeature:
      return <Tutorial />;
    case RPCFeature:
      return <RPC />;
  }
};

const hasFeature = (group) => {
  const features = [
    ShowcaseFeature,
    CategoriesFeature,
    ChannelsFeature,
    EmbedPresetsFeature,
    GroupsFeature,
    LikesFeature,
    PortfoliosFeature,
    FoldersFeature,
    TagsFeature,
    UsersFeature,
    VideosFeature,
    WatchLaterQueueFeature,
    LiveFeature,
    ApiAppsFeature,
    ApiInformationFeature,
    AuthenticationExtrasFeature,
    CinemaProgrammingFeature,
    ConfigsFeature,
    DeveloperSiteFeature,
    DocumentsFeature,
    ExactTargetFeature,
    GuestInterviewFeature,
    JobMarketplaceFeature,
    LastViewsFeature,
    LocationsFeature,
    MeFeature,
    NotificationsFeature,
    OnDemandFeature,
    ProductsFeature,
    SearchFeature,
    SongsFeature,
    StockFeature,
    TeamsFeature,
    TutorialFeature,
    RPCFeature,
  ];

  return features.indexOf(group) >= 0;
};

export { getFeature, hasFeature };
